// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import BlogCategories from "@store/Library/Components/Blog/Common/BlogCategories";
import BlogDate, { BlogDateStyles } from "@store/Library/Components/Blog/Common/BlogDate";
import BlogImage from "@store/Library/Components/Blog/Common/BlogImage";
import BlogTitle, { BlogTitleStyles } from "@store/Library/Components/Blog/Common/BlogTitle";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React from "react";
import { css } from "styled-components";

export interface BlogDetailsHeaderStyles {
    wrapper?: InjectableCss;
    categoriesDateWrapper?: InjectableCss;
}

export const blogDetailsHeaderStyles: BlogDetailsHeaderStyles = {
    categoriesDateWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: ${pxToRem(15, 0)};
            margin-bottom: ${pxToRem(20)};
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
};

const blogDateStyles: BlogDateStyles = {
    dateWrapper: {
        css: css`
            padding-bottom: 0;
        `,
    },
};

const blogTitleStyles: BlogTitleStyles = {
    textTitle: {
        css: css`
            padding-bottom: ${pxToRem(15)};
        `,
    },
};

const styles = blogDetailsHeaderStyles;

const BlogDetailsHeader = () => {
    const page = useCurrentPage();

    const {
        fields: { title, publicationDate, previewImage, categoriesList, isArchived, hideHourMinutes },
    } = page;

    return (
        <StyledWrapper {...styles.wrapper}>
            <BlogTitle forwardAs="h1" variant="h1" title={title} extendedStyles={blogTitleStyles} />
            <BlogImage previewImage={previewImage} altText={title} />
            <StyledWrapper {...styles.categoriesDateWrapper}>
                <BlogCategories categoriesList={categoriesList} isArchived={isArchived} />
                <BlogDate
                    publicationDate={publicationDate}
                    hideHourMinutes={hideHourMinutes}
                    extendedStyles={blogDateStyles}
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BlogDetailsHeader,
    definition: {
        group: constants.widgetGroup.blogDetails,
        displayName: "Blog Details Header",
        allowedContexts: ["BlogDetailsPage"] as any,
        fieldDefinitions: [],
    },
};

export default widgetModule;
